import PlayerManager from "../../../service/player-manager";
import SocketService from "../../../service/socket";
import ToastService from "../../../service/toast-service";
import PlaylistService from "../../../service/playlist-service";

const isInRoom = () => {
  const roomState = SocketService.getState();
  const { isJoined: isInRoom } = roomState;
  return isInRoom;
};

const playPlaylist = async ({ id, name }) => {
  if (isInRoom()) return ToastService.errorToast("Cannot play while in room.");
  ToastService.infoToast(`playing ${name}`);
  const playlist = await PlaylistService.getPlaylist({
    id,
  });
  const { songs } = playlist;
  if (songs && songs.length > 0) PlayerManager.playAll(songs);
  else ToastService.errorToast("cannot play empty playlist");
};

export { playPlaylist };
